const yup = require('yup')

const scheduleDateTime = () =>
  yup
    .mixed()
    .datetime()
    .when('schedule', { is: 'scheduled', then: (s) => s.required(), otherwise: (s) => s.transform(() => null) })

module.exports = scheduleDateTime
